
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TwoFaSetupPayload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFaSetupPayload"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"secret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recovery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"otpauthUrl"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":85}};
    doc.loc.source = {"body":"fragment TwoFaSetupPayload on TwoFaSetupPayload {\n  secret\n  recovery\n  otpauthUrl\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
